import "./Badge.scss";

const Badge = ({
    children,
    variant = "outlined",
    Icon, // Cambiado de 'icon' a 'Icon' (mayúscula inicial)
    iconPosition = "left",
    className = "",
    ...props
}) => {
    const badgeClasses = ["badge", `badge--${variant}`, className]
        .filter(Boolean)
        .join(" ");

    return (
        <span className={badgeClasses} {...props}>
            {Icon && iconPosition === "left" && (
                // Renderiza el componente Icon con su clase
                <Icon className="badge__icon" />
            )}
            {children && <span className="badge__text">{children}</span>}
            {Icon && iconPosition === "right" && (
                // Renderiza el componente Icon con su clase
                <Icon className="badge__icon" />
            )}
        </span>
    );
};

export default Badge;